'use client';

import React, { useState, useEffect } from 'react';
import { RoleFeatureBlock, ROLE_SECTION_ORDER } from './RoleHomepage';
import RoleHomepage from './RoleHomepage';

interface RoleHomepageOrchestratorProps {
  heroSection: React.ReactNode;
  philosophySection: React.ReactNode;
  marqueeSection: React.ReactNode;
  journeyMapSection: React.ReactNode;
  frameworkFlowSection: React.ReactNode;
  caretakerAssemblySection: React.ReactNode;
  bentoSection: React.ReactNode;
  destinationCardsSection: React.ReactNode;
  visionSection: React.ReactNode;
  resourceGuideSection: React.ReactNode;
  communityPhasesSection: React.ReactNode;
  ctaSection: React.ReactNode;
}

export default function RoleHomepageOrchestrator({
  heroSection,
  philosophySection,
  marqueeSection,
  journeyMapSection,
  frameworkFlowSection,
  caretakerAssemblySection,
  bentoSection,
  destinationCardsSection,
  visionSection,
  resourceGuideSection,
  communityPhasesSection,
  ctaSection,
}: RoleHomepageOrchestratorProps) {
  const [role, setRole] = useState<string>('explorer');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const savedRole = localStorage.getItem('haal_role') || 'explorer';
    setRole(savedRole);
  }, []);

  // Map section keys to actual components
  const SECTION_MAP: Record<string, React.ReactNode> = {
    'hero': heroSection,
    'role-feature': mounted && role && role !== 'explorer' ? <RoleFeatureBlock role={role} /> : null,
    'philosophy': philosophySection,
    'marquee': marqueeSection,
    'journey-map': journeyMapSection,
    'framework-flow': frameworkFlowSection,
    'caretaker-assembly': caretakerAssemblySection,
    'bento': bentoSection,
    'destination-cards': destinationCardsSection,
    'vision': visionSection,
    'resource-guide': resourceGuideSection,
    'community-phases': communityPhasesSection,
    'cta': ctaSection,
  };

  // Get section order for current role
  const sectionOrder = ROLE_SECTION_ORDER[role] || ROLE_SECTION_ORDER['explorer'];

  // Before mount, render default explorer order (SSR safe)
  if (!mounted) {
    return (
      <>
        {heroSection}
        {philosophySection}
        {marqueeSection}
        {journeyMapSection}
        {frameworkFlowSection}
        {caretakerAssemblySection}
        {bentoSection}
        {destinationCardsSection}
        {visionSection}
        {resourceGuideSection}
        {communityPhasesSection}
        {ctaSection}
      </>
    );
  }

  return (
    <RoleHomepage>
      <>
        {sectionOrder.map((sectionKey, i) => {
          const section = SECTION_MAP[sectionKey];
          if (!section) return null;
          return <React.Fragment key={`${sectionKey}-${i}`}>{section}</React.Fragment>;
        })}
        {/* Always render destination cards after bento regardless of role order */}
        {!sectionOrder.includes('destination-cards') && destinationCardsSection}
        {/* Always render community phases before CTA */}
        {!sectionOrder.includes('community-phases') && communityPhasesSection}
      </>
    </RoleHomepage>
  );
}
